export const PATH_KNOWLEDGE =
    '/knowledge/:category(all|lectures|diet|tips|motivation)';
export const PATH_KNOWLEDGE_ARTICLE = '/knowledge/:article';

export const PATH_ALL_ARTICLES = '/knowledge/all';
export const PATH_CATEGORY_LECTURES = '/knowledge/lectures';
export const PATH_CATEGORY_DIET = '/knowledge/diet';
export const PATH_CATEGORY_TIPS = '/knowledge/tips';
export const PATH_CATEGORY_MOTIVATION = '/knowledge/motivation';
